import { render, staticRenderFns } from "./Ottawa.vue?vue&type=template&id=5425cec1&"
import script from "./Ottawa.vue?vue&type=script&lang=js&"
export * from "./Ottawa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports